import React, { useEffect, useState } from "react";
import { Trash2, Edit, Search } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Apiurl from "../../environment/Apiurl";
import { useNavigate } from "react-router-dom";

function Staff({ toggleSidebar, sidebarOpen }) {
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showEntries, setShowEntries] = useState("10");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [userPrivileges, setUserPrivileges] = useState({});
  const [loadingPrivileges, setLoadingPrivileges] = useState(true);

  // Fetch user privileges
  const fetchUserPrivileges = async () => {
    try {
      setLoadingPrivileges(true);
      const userRole = localStorage.getItem("role_id") || "unknown";
      const token = localStorage.getItem("token");
      console.log("Fetching privileges for role_id:", userRole);
      if (userRole === "unknown") {
        console.warn("No role_id found in localStorage");
        setError(
          "No role assigned to the user. Please contact the administrator."
        );
        setTimeout(() => setError(null), 3000);
        return;
      }
      const response = await axios.get(`${Apiurl}/roles_and_privillage`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("Roles data fetched:", response.data);
      const roleData = response.data.find((role) => role.role_id === userRole);

      if (roleData) {
        console.log("User role data found:", roleData);
        const privileges = {};
        roleData.pages.forEach((page) => {
          privileges[page.page] = {
            ...page.priviallages,
            access: page.access,
          };
        });
        console.log("Set user privileges:", privileges);
        setUserPrivileges(privileges);
      } else {
        console.warn("User role not found:", userRole);
        setError("No role data found for the current user.");
        setTimeout(() => setError(null), 3000);
      }
    } catch (error) {
      console.error(
        "Error fetching user privileges:",
        error.message,
        error.response?.data
      );
      setError("Failed to fetch user privileges. Please try again.");
      setTimeout(() => setError(null), 3000);
    } finally {
      setLoadingPrivileges(false);
    }
  };

  // Check if user has specific permission
  const hasPermission = (permission) => {
    if (!userPrivileges || !userPrivileges["Staff"]) {
      console.log("No privileges found for Staff page");
      return false;
    }
    const privileges = userPrivileges["Staff"];
    console.log(`Checking permission '${permission}' for Staff:`, privileges);
    if (privileges.all) return true;
    const hasPerm = privileges[permission] || false;
    console.log(`Permission '${permission}' result:`, hasPerm);
    return hasPerm;
  };


    useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Fetch staff and doctor data
  const fetchData = async () => {
    if (!hasPermission("read")) {
      console.warn("No read permission for Staff");
      setError("You do not have permission to view staff data.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const userType = localStorage.getItem("user_type") || "unknown";
      const username = localStorage.getItem("username") || "";
      console.log("User type:", userType, "Username:", username);

      // Fetch staff data
      const staffResponse = await axios.get(`${Apiurl}/staff`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("Staff data fetched:", staffResponse.data);

      // Fetch doctor data
      let doctorData = [];
      try {
        const doctorResponse = await axios.get(`${Apiurl}/doctor`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        doctorData = doctorResponse.data || [];
        console.log("Doctor data fetched:", doctorData);
      } catch (doctorError) {
        console.warn(
          "No doctor data available or endpoint not found:",
          doctorError.message
        );
      }

      // Merge staff and doctor data, excluding logged-in staff
      const mergedData = [
        ...staffResponse.data
          .filter((item) => userType !== "Staff" || item.staff_id !== username)
          .map((item) => ({
            _id: item._id,
            user_type: "Staff",
            staff_id: item.staff_id,
            first_name: item.first_name,
            email: item.email,
            mobile_no: item.mobile_no,
            department: item.department,
            status: item.status,
          })),
        ...doctorData.map((item) => ({
          _id: item._id,
          user_type: "Doctor",
          staff_id: item.doctor_id,
          first_name: item.doctor_name,
          email: item.email,
          mobile_no: item.mobile_no,
          department: item.department,
          status: item.status,
        })),
      ];
      // console.log("Merged data for display:", mergedData);
      console.log("Merged data for display:", staffResponse);

      let staff_data;
      // new code to set only login staff data to show
      if (userType == "Staff") {
        console.log("the if condition is executed");
        const staffResponse = await axios.get(
          `${Apiurl}/single_staff/${username}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setResponseData(staffResponse.data);

        console.log(staffResponse.data);
      } else {
        console.log("the else condition is executed");

        const staffResponse = await axios.get(`${Apiurl}/staff`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setResponseData(staffResponse.data);

        console.log(staffResponse.data);
      }

      // setResponseData(mergedData);

      setError(null);
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.message,
        error.response?.data
      );
      setError(`Failed to fetch staff and doctor data: ${error.message}`);
      setResponseData([]);
      setTimeout(() => setError(null), 5000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("Fetching initial data...");
    fetchUserPrivileges();
  }, []);

  useEffect(() => {
    if (hasPermission("read")) {
      console.log("Fetching staff and doctor data due to read permission...");
      fetchData();
    }
  }, [userPrivileges]);

  // Handle delete
  const openDeleteModal = (id) => {
    if (!hasPermission("delete")) {
      console.warn("No delete permission for Staff");
      setError("You do not have permission to delete staff.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    console.log("Opening Delete Staff modal for ID:", id);
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    console.log("Closing Delete Staff modal");
    setShowDeleteModal(false);
    setDeleteId(null);
    setError(null);
  };

  const confirmDelete = async () => {
    if (!hasPermission("delete")) {
      console.warn("No delete permission for Staff");
      setError("You do not have permission to delete staff.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    try {
      console.log("Deleting user with ID:", deleteId);
      const token = localStorage.getItem("token");
      await axios.delete(`${Apiurl}/staff/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchData();
      closeDeleteModal();
    } catch (error) {
      console.error(
        "Error deleting user:",
        error.message,
        error.response?.data
      );
      setError("Failed to delete user. Please try again.");
      setTimeout(() => setError(null), 3000);
    }
  };

  // Handle edit
  const handleEdit = (id) => {
    if (!hasPermission("update")) {
      console.warn("No update permission for Staff");
      setError("You do not have permission to edit staff.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    console.log("Navigating to edit user with ID:", id);
    toggleSidebar();
    navigate(`/hr-management/staff/update-staff/${id}`);
  };

  // Handle add staff
  const handleAddStaff = () => {
    if (!hasPermission("create")) {
      console.warn("No create permission for Staff");
      setError("You do not have permission to add staff.");
      setTimeout(() => setError(null), 3000);
      return;
    }
    console.log("Navigating to add staff page");
    toggleSidebar();
    navigate("/hr-management/staff/add-staff");
  };

  // Filter data
  const filteredData = responseData.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.staff_id?.toLowerCase().includes(term) ||
      item.first_name?.toLowerCase().includes(term) ||
      item.email?.toLowerCase().includes(term) ||
      item.mobile_no?.toLowerCase().includes(term) ||
      item.department?.toLowerCase().includes(term)
    );
  });
  console.log("Filtered data:", filteredData);

  // Update items per page
  useEffect(() => {
    console.log("Updating items per page to:", showEntries);
    if (showEntries === "All") {
      setItemsPerPage(filteredData.length || 1);
    } else {
      setItemsPerPage(Number(showEntries));
    }
  }, [showEntries, filteredData]);

  // Reset current page on search or items per page change
  useEffect(() => {
    console.log(
      "Resetting current page due to searchTerm or itemsPerPage change"
    );
    setCurrentPage(1);
  }, [searchTerm, itemsPerPage]);

  // Pagination calculations
  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
  console.log(
    "Pagination - totalPages:",
    totalPages,
    "itemsPerPage:",
    itemsPerPage,
    "filteredData.length:",
    filteredData.length
  );
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  console.log(
    "Current items:",
    currentItems,
    "from index",
    indexOfFirstItem,
    "to",
    indexOfLastItem
  );

  // Generate page list
  const getPageList = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    console.log("Generated page list:", pages);
    return pages;
  };

  const pages = getPageList();

  const handlePageClick = (page) => {
    if (page !== "..." && page !== currentPage) {
      console.log("Navigating to page:", page);
      setCurrentPage(page);
    }
  };

  if (loadingPrivileges) {
    return <div className="p-3">Loading permissions...</div>;
  }

  if (!hasPermission("access")) {
    console.log(
      "Access denied for role_id:",
      localStorage.getItem("role_id"),
      "on Staff page"
    );
    return (
      <div className="p-3">
        <div className="alert alert-danger">
          You don't have permission to access this page.
        </div>
      </div>
    );
  }

  return (
    <div className="p-3">
      <style>{`
        .btn-custom { 
          background-color: #01AEBE; 
          color: white; 
          border: none;
        }
        .btn-custom:hover { 
          background-color: #018A97; 
          color: white;
        }
      `}</style>

      {hasPermission("create") && (
        <div className="text-end mb-3">
          <button className="btn btn-custom btn-sm" onClick={handleAddStaff}>
            <i className="fas fa-plus me-2"></i> Add Staff
          </button>
        </div>
      )}

      {error && (
        <div className="alert alert-danger alert-dismissible fade show mt-2">
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError(null)}
          ></button>
        </div>
      )}

      {hasPermission("read") && (
        <div className="card card-body mt-2">
          <div className="bg-white rounded shadow-sm p-3">
            <div className="row mb-3 crm-table-toolbar">
              <div className="col-md-2">
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="fas fa-table"></i>
                  </span>
                  <select
                    className="form-select"
                    value={showEntries}
                    onChange={(e) => {
                      console.log(
                        "Changing items per page to:",
                        e.target.value
                      );
                      setShowEntries(e.target.value);
                    }}
                  >
                    <option value="All">Show All</option>
                    {[5, 10, 20, 50, 100, 200, 500, 1000].map((n) => (
                      <option key={n} value={n}>
                        Show {n}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-7"></div>
              <div className="col-md-3">
                <div className="d-flex align-items-center">
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control pe-5"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => {
                        console.log("Search term changed to:", e.target.value);
                        setSearchTerm(e.target.value);
                      }}
                      style={{ width: "250px", paddingRight: "2.5rem" }}
                    />
                    <Search
                      size={16}
                      className="position-absolute text-muted"
                      style={{
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-100%)",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {loading && <div className="text-center py-3">Loading...</div>}

            <div className="table-responsive">
              <table className="table table-hover">
                <thead style={{ backgroundColor: "#01AEBE", color: "white" }}>
                  <tr>
                    <th>S.No</th>
                    <th>Staff ID</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Department</th>
                    <th>Status</th>
                    {(hasPermission("update") || hasPermission("delete")) && (
                      <th>Action</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length > 0 ? (
                    currentItems.map((item, index) => (
                      <tr key={item._id || index} className="align-middle">
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{item.staff_id || "-"}</td>
                        <td>{item.first_name || "-"}</td>
                        <td>{item.email || "-"}</td>
                        <td>{item.mobile_no || "-"}</td>
                        <td>{item.department || "-"}</td>
                        <td>
                          <span
                            className={`badge rounded-pill px-3 py-2 fw-semibold d-inline-flex align-items-center ${
                              item.status?.toLowerCase() === "active"
                                ? "bg-success text-white"
                                : "bg-danger text-white"
                            }`}
                          >
                            <FontAwesomeIcon
                              icon={
                                item.status?.toLowerCase() === "active"
                                  ? faCheckCircle
                                  : faTimesCircle
                              }
                              className="me-2"
                            />
                            {item.status?.charAt(0).toUpperCase() +
                              item.status?.slice(1).toLowerCase() || "-"}
                          </span>
                        </td>
                        {(hasPermission("update") ||
                          hasPermission("delete")) && (
                          <td>
                            {hasPermission("delete") && (
                              <button
                                className="btn btn-sm p-1 border-0"
                                style={{ backgroundColor: "transparent" }}
                                onClick={() => openDeleteModal(item._id)}
                              >
                                <Trash2 size={16} className="text-danger" />
                              </button>
                            )}
                            {hasPermission("update") && (
                              <button
                                className="btn btn-sm p-1 border-0"
                                style={{ backgroundColor: "transparent" }}
                                onClick={() => handleEdit(item._id)}
                              >
                                <Edit size={16} className="text-primary" />
                              </button>
                            )}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={
                          hasPermission("update") || hasPermission("delete")
                            ? 8
                            : 7
                        }
                        className="text-center py-3"
                      >
                        {loading ? "Loading..." : "No staff or doctors found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="container">
              <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() =>
                    currentPage > 1 && setCurrentPage(currentPage - 1)
                  }
                  disabled={currentPage === 1}
                >
                  <i className="fas fa-chevron-left"></i>
                  <span className="d-none d-sm-inline">Previous</span>
                </button>

                <div
                  className="d-flex overflow-auto flex-nowrap gap-2 px-2"
                  style={{ maxWidth: "100%" }}
                >
                  {pages.map((page, index) => (
                    <button
                      key={index}
                      className={`btn btn-sm px-3 flex-shrink-0 ${
                        page === currentPage
                          ? "text-white"
                          : "btn-outline-secondary"
                      }`}
                      style={
                        page === currentPage
                          ? { backgroundColor: "#20c997", border: "none" }
                          : {}
                      }
                      onClick={() => handlePageClick(page)}
                      disabled={page === "..."}
                    >
                      {page}
                    </button>
                  ))}
                </div>

                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() =>
                    currentPage < totalPages && setCurrentPage(currentPage + 1)
                  }
                  disabled={currentPage === totalPages}
                >
                  <span className="d-none d-sm-inline">Next</span>
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {hasPermission("delete") && showDeleteModal && (
        <div
          className={`modal fade show`}
          style={{ display: "block" }}
          tabIndex="-1"
          aria-labelledby="deleteStaffModalLabel"
          aria-hidden="false"
        >
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content" style={{ borderRadius: "10px" }}>
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeDeleteModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center">
                <div style={{ marginBottom: "15px" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#fee2e2",
                      borderRadius: "50%",
                      textAlign: "center",
                      lineHeight: "40px",
                    }}
                  >
                    <i
                      className="fas fa-exclamation-triangle"
                      style={{ color: "#dc2626", fontSize: "20px" }}
                    ></i>
                  </span>
                </div>
                <h5 className="modal-title" id="deleteStaffModalLabel">
                  Delete Staff
                </h5>
                <p style={{ marginTop: "10px" }}>
                  Are you sure you want to delete this staff?
                </p>
              </div>
              <div
                className="modal-footer"
                style={{ borderTop: "none", justifyContent: "center" }}
              >
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#e0e0e0",
                    color: "#333",
                  }}
                  onClick={closeDeleteModal}
                >
                  No, Keep it
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={confirmDelete}
                  disabled={loading}
                >
                  {loading ? "Deleting..." : "Yes, Delete It!"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {hasPermission("delete") && showDeleteModal && (
        <div className="modal-backdrop fade show"></div>
      )}
    </div>
  );
}

export default Staff;
